import { localeReducer as locale } from "data/reducers/locale";
import { reducer as regionalEmbed } from "lib/api/embeds/regional";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  regionalEmbed,
  locale,
});
